import React from 'react';
import { ButtonProps, Dropdown } from 'react-bootstrap';
import i18next from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Languages } from '../../core/enums/Languages';
import Icon from '../icon/Icon';
import AccountService from '../../core/services/AccountService';
import { AuthStatus } from '../../core/enums/AuthStatus';
import { RootState } from '../../core/state/state';
import { getUserInfo } from '../../core/state/user/asyncActions';

import './LanguagePicker.scss';

const getClass = (defaultLng: string | null, lng: string | null) => {
  return `language-picker__menu-item ${defaultLng === lng ? 'language-picker__menu-item--active' : ''}`;
};

const LanguagePicker: React.FC = () => {
  const [language, setLanguage] = React.useState<string | null>(Languages.De);
  const status = useSelector((state: RootState) => state.auth.status);
  const userInfo = useSelector((state: RootState) => state.user.userInfo);
  const { projectId } = useParams<{ projectId: string }>();
  const dispatch = useDispatch();

  const ToggleButton = React.forwardRef<HTMLButtonElement, ButtonProps>(({ children, onClick }, ref) => (
    <button
      ref={ref}
      className="language-picker__btn"
      onClick={(e) => {
        e.preventDefault();
        if (onClick) {
          onClick(e);
        }
      }}
    >
      {children}
    </button>
  ));

  const changeLanguage = async (lng: Languages) => {
    setLanguage(lng);
    i18next.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);
    if (status === AuthStatus.Authenticated) {
      await AccountService.changeLanguage(lng);
      dispatch(getUserInfo(Number(projectId)));
    }
  };

  React.useEffect(() => {
    const lng = localStorage.getItem('i18nextLng');
    if (userInfo) {
      i18next.changeLanguage(userInfo.lang);
      setLanguage(userInfo.lang);
      localStorage.setItem('i18nextLng', userInfo.lang);
    } else if (lng) {
      i18next.changeLanguage(lng);
      setLanguage(lng);
    } else {
      localStorage.setItem('i18nextLng', Languages.De);
    }
  }, [userInfo]);

  return (
    <Dropdown className="language-picker">
      <Dropdown.Toggle as={ToggleButton} id="select-language">
        <span className="language-picker__title">{language?.split('-')[1]}</span>
        <Icon className="language-picker__icon" icon="arrow" size="extra-small" svg />
      </Dropdown.Toggle>
      <Dropdown.Menu className="language-picker__menu" area-labelby="select-language">
        <Dropdown.Item className={getClass(language, Languages.En)} onClick={() => changeLanguage(Languages.En)}>
          {Languages.En.split('-')[1]}
        </Dropdown.Item>
        <Dropdown.Item className={getClass(language, Languages.De)} onClick={() => changeLanguage(Languages.De)}>
          {Languages.De.split('-')[1]}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguagePicker;
